module.exports = __webpack_public_path__ + "img/l1@2x.663c231e.png";